import { atom } from "recoil";

const fetchState = atom<Record<string, any>>({
    key: "fetchState",
    default: {
        requests: {},
    },
});

export default fetchState;
